module.exports = __webpack_public_path__ + "static/home-f1c4e748aaaf63499a9c06bb99a13014.jpg";